module.exports = __webpack_public_path__ + "static/media/Union.22a5f425.svg";